/*
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 * @author    Afternet <info@afternet.gr>
 * @copyright Afternet
 * @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 */

export default class Headerlider{
    init (){
        if($('.js-header-slider').length){

            var swiper = new Swiper(".js-header-slider", {
                slidesPerView: 1,
                centeredSlides: true,
                watchOverflow: true,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                pagination: {
                    el: ".js-header-slider-pagination",
                    clickable: true,
                },
                // navigation: {
                //     nextEl: '.js-header-slider-next',
                //     prevEl: '.js-header-slider-prev'
                // }
            });
        }
    }
}